import { render, staticRenderFns } from "./PortcallclearancesstatusFormHeader.vue?vue&type=template&id=8ddf103a"
import script from "./PortcallclearancesstatusFormHeader.vue?vue&type=script&lang=js"
export * from "./PortcallclearancesstatusFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports